import { CompanyContext } from 'context'
import { useContext } from 'react'

export function useCompany() {
  return useContext(CompanyContext)
}
